
export const Steps = {
   'ALL': {
      name: 'ALL',
      display: 'ALL',
      code: 'ALL'
   },
   'NO_KANBAN': { name: 'NO_KANBAN',
              display: '',
              code: 'NO_KANBAN'},
   'En Stock': { name: 'step_10',
              display: 'En Stock',
              code: 'STEP_WS_10'},
   'Attente commande': { name: 'step_20',
              display: 'Att. com',
              code: 'STEP_WS_20'},
   'Commandé': { name: 'step_30',
              display: 'Commandé',
              code: 'STEP_WS_30'},
   'En Préparation': { name: 'En Préparation',
              display: 'En Prép.',
              code: 'En Préparation'},
   'Cellule 1': { name: 'Cellule 1',
              display: 'Cellule 1',
              code: 'Cellule 1'},
   'Cellule 2': { name: 'Cellule 2',
              display: 'Cellule 2',
              code: 'Cellule 2'},
   'Cellule 3': { name: 'Cellule 3',
              display: 'Cellule 3',
              code: 'Cellule 3'},
}


// WEBPACK FOOTER //
// ./src/core/services/steps.js